import styled from "styled-components";

export const BodyText = styled.div`
    background: #fff;

    @media screen and (max-width: 768px) {
        padding-top: 60px;
    }
`

export const TextContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 30px;
    position: relative;
    z-index: 1;
    flex-direction: column;
    background: #fff;
    min-height: 100vh;

    @media screen and (max-width: 768px) {
        padding: 40px 20px;
    }
`

export const Box = styled.div`
    max-width: 1200px;
    width: 100%;
    padding: 40px;
    background: #fff;
    border-radius: 12px;
    margin-bottom: 30px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;
    line-height: 1.7;
    font-size: 16px;
    color: #333;

    @media screen and (max-width: 768px) {
        padding: 30px 20px;
        margin-bottom: 20px;
        font-size: 15px;
    }

    p {
        margin-bottom: 24px;
        line-height: 1.8;
    }

    b {
        color: #2c5282;
        font-weight: 600;
    }

    i {
        color: #38A7BA;
        font-style: italic;
        font-weight: 500;
    }

    u {
        text-decoration: underline;
        text-decoration-color: #e53e3e;
        text-underline-offset: 2px;
    }

    ol {
        margin-top: 40px;
        padding-left: 20px;
        background: #f8f9ff;
        border-radius: 8px;
        padding: 30px;
        border-left: 4px solid #38A7BA;

        @media screen and (max-width: 768px) {
            padding: 20px 15px;
            margin-top: 30px;
        }
    }

    li {
        margin-bottom: 16px;
        font-size: 14px;
        line-height: 1.6;
        color: #4a5568;
        list-style-type: decimal;

        @media screen and (max-width: 768px) {
            font-size: 13px;
            margin-bottom: 12px;
        }
    }

    a {
        color: #38A7BA;
        text-decoration: none;
        transition: color 0.3s ease;

        &:hover {
            color: #2c5282;
            text-decoration: underline;
        }
    }
`

export const BoxTitle = styled.h1`
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 30px;
    color: #2d3748;
    text-align: center;
    position: relative;
    padding-bottom: 20px;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 3px;
        background: linear-gradient(90deg, #38A7BA, #2c5282);
        border-radius: 2px;
    }

    @media screen and (max-width: 768px) {
        font-size: 28px;
        margin-bottom: 25px;
    }

    @media screen and (max-width: 480px) {
        font-size: 24px;
        margin-bottom: 20px;
    }
`

export const ContentText = styled.div`
    text-align: justify;
    
    br {
        line-height: 2;
    }

    @media screen and (max-width: 768px) {
        text-align: left;
    }
`
